<script lang="ts">
	import { browser } from "$app/environment";
  import { page } from "$app/stores";
	import { Icon } from "$lib/components/atoms/Icon";

  export let pagesLength: number = 0;
  export let currentPage: number = 0;
  export let listingPageSlug: string;

  const getURL = (pageNumber: number) => {
    let url = `/${listingPageSlug}`; 
    if (pageNumber > 1) {
      url += `/page-${pageNumber}`;
    }

    if (browser && $page.url.searchParams.size > 0) {
      const urlQuery = Array.from($page.url.searchParams.entries())
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
      
      url += `?${urlQuery}`;
    }

    return url;
  };
</script>

{#key $page.url.search}
  <nav aria-label="Page navigation">
    <ul class="pagination-container">
      <li>
        {#if currentPage < 1}
          <button disabled class="pagination-button border-l rounded-l disabled">
            <Icon icon="arrow-left" size="small" />
          </button>
        {:else}
          <a href={getURL(currentPage)} class="pagination-button border-l rounded-l" target="_self">
            <Icon icon="arrow-left" size="small" />
          </a>
        {/if}
      </li>
      {#each Array(pagesLength) as _, index}
        <li>
          <a
            href={getURL(index + 1)}
            class="navigation-link"
            class:bg-gray-50={currentPage === index}
            target="_self"
          >
            {index + 1}
          </a>
        </li>
      {/each}
      <li>
        {#if currentPage + 1 >= pagesLength}
          <button disabled class="pagination-button rounded-r disabled">
            <Icon icon="arrow-right" size="small" />
          </button>
        {:else}
          <a href={getURL(currentPage + 2)} class="pagination-button rounded-r" target="_self">
            <Icon icon="arrow-right" size="small" />
          </a>
        {/if}
      </li>
    </ul>
  </nav>
{/key}

<style type="text/scss" lang="scss" scoped>
  .pagination-container {
    @apply w-full;
    @apply flex items-center text-base justify-center;
    @apply h-10;
  }

  .pagination-button {
    @apply flex items-center justify-center;
    @apply px-4 h-10 leading-tight;
    @apply text-gray-700 hover:text-black;
    @apply border-t border-b border-r border-gray-300;
  }

  .disabled {
    @apply pointer-events-none;
    @apply text-gray-300 hover:text-gray-300;
  }

  .navigation-link {
    @apply flex items-center justify-center;
    @apply px-4 h-10;
    @apply leading-tight text-gray-700 hover:text-black;
    @apply border-t border-b border-r border-gray-300 border-l-0;
  }
</style>
